import { getContractSweepRequestRecord } from "src/api/contactSweepRequestRecord";
import PageConfigProvider from "src/features/PageConfigProvider";
import ViewFilterTable from "./ViewFilterTable";
import { initFields } from "./constants/initFields";
import useGetListParams from "./hooks/useGetListParams";

const ContractSweepRequestRecord = () => {
  const { getListParams } = useGetListParams();
  return (
    <PageConfigProvider
      translatePrefix="contractSweepRequestRecord"
      initFields={initFields}
      getTableDataApiFunc={getContractSweepRequestRecord}
      getListParams={getListParams}>
      <ViewFilterTable />
    </PageConfigProvider>
  );
};

export default ContractSweepRequestRecord;
